<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                    Take Your Video
                                </h1>
                                <p class="custom-16px-400 text-center ml-4">
                                    Get to know the talented individuals driving our company forward.
                                </p>
    
                                <br /><br /><br />
                                <CContainer>
                                    <CRow>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconcamera.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    Upload
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Self-recording to answer instant questions on the Interviewrr portal and get expert feedback through the email/portal.
                                                </p>
                                            </CCard>
                                        </CCol>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconai.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    AI Review
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Our AI-powered platform offers top-notch feedback,<br /> along with exclusive insights<br /> from industry experts.
                                                </p>
                                            </CCard>
                                        </CCol>
                                        <CCol sm="4">
                                            <CCard class="bg-white b-20 p-20" style="border:none">
                                                <img src="../assets/img/iconrefine.png" style="width:30px" class="m-4" />
                                                <h3 class="custom-24px-500 text-left ml-4">
                                                    Refinement
                                                </h3>
                                                <p class="custom-16px-400 text-left ml-4">
                                                    Tailored feedback to enhance user resume <br />and increase their chances <br /> of landing a job.
                                                </p>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </div>
                        </div>
                        <br />
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <CRow>
                    <CCol sm="12">
                        <h3 class="custom-30px-600 mt-4">Interview Question</h3>
                    </CCol>
                    <CCol sm="9">
                        <label class="custom-20px-500" v-if="showInstruction">{{ instructionText }}</label>
                        <label class="custom-20px-500" v-if="showQuestion === true">{{ questions.index }} .{{ questions.question }}</label
                      >
                      <label class="custom-20px-500" v-if="showQuestion2 === true"
                        >{{ question.index }} .{{ question.question }}</label
                      >
                      </CCol>
                      <CCol sm="3">
                        <div class="text-right">
                            
                          <span
                            class="custom-border-purple p-2"
                            style="width:120px"
                            @click="GoToNextQuestion(index, questions.sessionId)"
                            :class="{ disabled: isNextButtonDisabled }"
                            v-if="index < 7"><span class="ml-5 mr-5">Next</span>
                            </span>
                            <span
                            v-else
                            class="custom-border-purple p-2"
                            style="width:120px"
                            @click="OpenProfile()"
                            ><span class="ml-5 mr-5">View All</span></span
                          >
                        </div>
                      </CCol>
                      <CCol sm="12">
                        <div class="video-container">
                          <video
                            :class="{ hideAfterStop: toggleVideo }"
                            ref="videoElement"
                            autoplay
                          ></video>
                          <div class="timer" v-if="isRecording">{{ formatTime(elapsedTime) }} / 02:00</div>
                          <div class="button-container">
                            <CRow>
                              <CCol sm="4">
                              
                                <button
                                  class="record-button"
                                  @click="toggleRecording(index)"
                                  :class="{ recording: isRecording }"
                                >
                                  <i v-if="!isRecording" class="fas fa-play"></i>
                                  <i v-else class="fas fa-stop"></i>
                                </button>
                              </CCol>
                            </CRow>
                          </div>
                          <!-- <video ref="videoResult" controls style="display: none;"></video> -->
                        </div>
                      </CCol>
                      <CCol sm="12">
                              <CRow>
                                  <CCol v-if="uploadProgress > 0" sm="12">
                                      <p class="custom-14px-500 mt-3 font-color-171717">Upload Process – {{ uploadProgress }}%</p>
                                      <p class="custom-14px-500 font-color-171717">After uploading the video you can click next to continue the interview</p>
                                      <progress v-if="uploadProgress > 0" style="width: 100%" :value="uploadProgress"></progress>
                                      <!-- Indikator progres -->
                                  </CCol>
                                  <CCol sm="12">
                                      <h4 class="custom-20px-700 mt-4">
                                          Tips For Answer
                                      </h4>
                                      <p class="custom-18px-500 font-color-171717">
                                          Please respond to the question based on your understanding of the subject, recording yourself using your computer's camera within the allocated time. Ensure you have good lighting, minimal background noise, and aim for a high-quality recording to enhance
                                          your presentation.
                                      </p>
                                  </CCol>
                              </CRow>
                          </CCol>
                      </CRow>
                  </CContainer>
              </CCol>


              <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
                  <br />
                  <br />
                  <br />
                  <CCol sm="12" lg="12">
                      <div class="text-center p-2">
                          <CCol sm="12" style="width: 80%;margin: auto;">
                              <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <h1 class="custom-header-join text-white poppin-font text-48px mt-5">
                                      Subscribe Now for Free
                                  </h1>
                                  <br />
                                  <label class="custom-header-join-sub text-white">
                            Sign up now for free and take the first step toward landing your
                            dream job!
                          </label>
                        <br />
                        <br />
                        <br />
                        <br />
                        <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
    </div>
    </CCol>
    </div>
    <br /><br /><br />
    </CCol>
    </CCol>
    
    <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <img style="max-width: 100px" src="../assets/img/rightstar.png" />
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Thank you for completing <br /> the interview.</h3>
                <h3 class="custom-16px-400 text-center">
                    Your responses are being carefully reviewed, and we will notify you of the results within the next 2 days. 
                </h3>
            </div>

            <CButton class="custom-border-purple text-white" @click="OpenFeedback()" block><span class="ml-2 mr-2">Feedback AI Interviewrr</span></CButton>
            
            <div class="text-center mt-3">
                <span class="text-center font-color-615FCD" @click="closePopup2()">Not Now</span>
            </div>
        </div>
    </div>

    <div v-if="PopupFeedback" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Rate Interview</h3>
                <h3 class="custom-16px-400 text-center">
                    Your responses are being carefully reviewed, and we will notify you of the results within one day.  
                </h3>
                <h4 class="custom-16px-400 text-center mt-2">Rating</h4>
                <div id="star-container">
      <img 
        v-for="index in 5" 
        :key="index" 
        :src="getStarSrc(index)" 
        @click="updateStars(index)" 
        class="star" 
        style="width:56px"
        :class="{ grey: index > rating, yellow: index <= rating }" 
      />
    </div>

                <CTextarea v-model="comment" placeholder="enter your story about AI Interview" class="mt-3"/>
            </div>

            <CButton class="custom-border-purple text-white" @click="SubmitFeedback" block><span class="ml-2 mr-2">Send Feedback AI Interviewrr</span></CButton>
         
        </div>
    </div>

    <div v-if="SuccessPopupFeedback" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <img style="max-width: 100px" src="../assets/img/success.png" />
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Success!</h3>
                <h3 class="custom-16px-400 text-center">
                    Your review is succesfully added
                </h3>
            </div>

            <CButton class="custom-border-purple text-white" @click="closeSuccessFeedback()" block><span class="ml-2 mr-2">Ok</span></CButton>
            
         \
        </div>
    </div>
    
          
         
 
    
    <Footerlayout></Footerlayout>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from "../components/Toggle.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopupFeedback: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {}
      
        };
    },
    created() {
        AOS.init();
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                this.getFirstQuestion();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async startRecording(index) {
        try {
            await this.GetCheckingUploadVideo(index,this.questions.sessionId)
            
            if(this.checking === false)
            {
                this.showInstruction = false;
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    frameRate: { ideal: 30 },
                },
                audio: {
                    echoCancellation: true, // Apply echo cancellation
                    noiseSuppression: true, // Apply noise suppression
                    sampleRate: 44100,
                },
            });
            this.$refs.videoElement.srcObject = stream;
            this.$refs.videoElement.muted = true;

            this.mediaRecorder = new MediaRecorder(stream);

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.recordedChunks.push(event.data);
                }
            };

            this.mediaRecorder.onstop = () => {
                const recordedBlob = new Blob(this.recordedChunks, {
                    type: "video/webm",
                });

                this.recordedChunks = [];

                const formData = new FormData();
                formData.append("file", recordedBlob, "rekaman.webm");
                formData.append("sessionId", this.questions.sessionId);
                formData.append("indexNo", index);
                formData.append("userId", this.user.id);

                this.$API.post(this.$uploadFile, formData, {
                    onUploadProgress: (progressEvent) => {
                        this.uploadProgress = Math.round(
                            (progressEvent.loaded / progressEvent.total) * 100
                        );
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        this.videoId = response.data.videoId;
                        this.InsertVideoText(this.videoId);
                        console.log("Succesfully uploaded.");
                    } else {
                        console.error("Failed to upload.");
                    }
                }).catch((error) => {
                    console.error("Error:", error);
                });
                this.isNextButtonDisabled = false;
            };

            this.mediaRecorder.start();
            this.isRecording = true;
            this.isNextButtonDisabled = true;
            this.elapsedTime = 0;
            this.timerInterval = setInterval(() => {
                this.elapsedTime++;
                if (this.elapsedTime >= 120) {
                    this.stopRecording();
                }
            }, 1000);

            // Display the question when recording starts
            if (index === 1) {
                this.showQuestion = true;
                this.showQuestion2 = false;
            } else {
               
                this.showQuestion2 = true;
                this.showQuestion = false;
                this.getListQuestion(index, this.questions.sessionId);
               
            }

            }
            
            else{
                alert("Error. You already submit this question.Please proceed to the next question by click button Next");
            }
           
            //this.index++;

        } catch (error) {
            console.error("Error accessing media devices: ", error);
            alert("Error accessing media devices.No device found");
        }
    },
        stopRecording() {
            if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
                this.mediaRecorder.stop();
                const tracks = this.$refs.videoElement.srcObject.getTracks();
                tracks.forEach((track) => track.stop());

                this.$refs.videoElement.srcObject = null;
                this.recordedChunks = [];
                this.uploadProgress = 0;
                this.isRecording = false;
                clearInterval(this.timerInterval); // Stop the timer
                this.timerInterval = null;
                clearTimeout(this.stopRecordingTimeout);


            }
        },
        async GetCheckingUploadVideo(index, sessionId) {
            try {
                const response = await this.$API.get(this.$CheckVideoSessionIndex + "?sessionId=" + sessionId + "&indexNo=" + index);
                if (response.status === 200) {
                    this.checking = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        InsertVideoText(videoId) {

            this.$API
                .get(this.$ExtractAudioText + "/" + videoId)
                .then((response) => {

                    if (response.status == 200) {
                        console.log("success convert");
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },


        toggleRecording(index) {
            if (this.isRecording) {
                this.stopRecording();
            } else {
                this.startRecording(index);
            }
        },
        async GoToNextQuestion(index, sessionId) {
            this.showInstruction = true;
            this.showQuestion2 = false;
            this.showQuestion = false;
            this.index++;
            //this.getListQuestion(index, sessionId);

        },
        async getFirstQuestion() {
            try {
                const codeCompany = this.$route.query.code;

                if(codeCompany != null)
                {
                    const response = await this.$API.get(`${this.$GetFirstQuestionByCode}?code=${codeCompany}`,
                                    { withCredentials: true }

                );

                if (response.status === 200) {

                    this.questions = response.data;
                } else {}

                }
                else
                {

                
                const position = this.$route.query.position;

                const response = await this.$API.get(
                    `${this.$GetFirstQuestion}/${position}`, {
                        withCredentials: true,
                    }
                );

                if (response.status === 200) {

                    this.questions = response.data;
                } else {}
            }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListQuestion(index, sessionId) {
            this.showQuestion = false;
            if (index >= 7) {
                this.stopRecording();
                this.SubmitData();
            } else {
                try {
                const codeCompany = this.$route.query.code;

                if(codeCompany != null)
                {
                    const response = await this.$API.get(
                        `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index}&code=${codeCompany}`, {
                            withCredentials: true,
                        }
                    );
                    if (response.status === 200) {
                     


                        if (response.data === 'Skip') {
                            const response = await this.$API.get(
                            `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index+1}&code=${codeCompany}`, {
                                withCredentials: true,
                            });
                            this.question = response.data;
                        this.showQuestion = false;
           
                        }
                        else
                        {
                            this.question = response.data;
                        this.showQuestion = false;

                        }
          


                    } else {}

                }
                else
                {
                    const response = await this.$API.get(
                        `${this.$GetNextQuestion}/${sessionId}/${index}`, {
                            withCredentials: true,
                        }
                    );
                    if (response.status === 200) {
                        this.question = response.data;
                        this.showQuestion = false;
                    } else {}

                }
                } catch (error) {}
            }
        },
        SubmitData() {
        
            const field = this.$route.query.field;
            const expertise = this.$route.query.expertise;

            const formData = new FormData();

            formData.append("email", this.user.email);
            formData.append("experties", expertise);
            formData.append("field", field);

            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                                this.isLanguagePopupVisible2 = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenProfile() {
            this.$router.push("Profile");
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        closePopup2()
        {
            this.isLanguagePopupVisible2 = false;
        },
        OpenFeedback()
        { 
            this.isLanguagePopupVisible2 = false;
            this.PopupFeedback = true;
        },
        updateStars(index) {
        this.rating = index;
        },
        getStarSrc(index) {
    return index <= this.rating ? require('../assets/img/star-yellow.png') : require('../assets/img/star-grey.png');
  },
        SubmitFeedback()
        {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("comment", this.comment);
            formData.append("rate", this.rating);

            this.$API
                .post(this.$SubmitFeedbacks, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                            
                                this.SuccessPopupFeedback = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessFeedback()
        {
            this.PopupFeedback = false;
            this.SuccessPopupFeedback = false;
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
    },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
    top: 0 !important;
    font-family: "General Sans", sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}
</style>
